import React from 'react';

import { ListDataInterface } from '@/types/components';

import { ListBlock } from '../List';

const DeliveryPolicy = ({
  data,
}: {
  data: ListDataInterface[];
}): JSX.Element => {
  return <ListBlock title="Delivery Policy" data={data} />;
};

export default DeliveryPolicy;
